import React from 'react'
import { connect } from 'react-redux'

import Snackbar from '../Snackbar'
import { closeSnackbar } from './actions'
import {getSnackbarSelector} from "../../utils/redaxSelectors";


const mapStateToProps = (state) => ({
  snackbar: getSnackbarSelector(state),
});


function SnackbarProvider(props) {

  let {
    snackbar
  } = props;

  return (
    <Snackbar
      open={snackbar.open}
      variant={snackbar.variant}
      message={snackbar.message}
      handleClose={() => props.dispatch(closeSnackbar())}
      autoHideDuration={snackbar.duration}
    />
  )
}

SnackbarProvider.propTypes = {

};

export default connect(mapStateToProps)(SnackbarProvider)

